"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _decorators = require("decorators");

var _Listener = babelHelpers.interopRequireDefault(require("components/Notifications/Listener"));

var _class;

var Retake = (_class =
/*#__PURE__*/
function (_Activity) {
  babelHelpers.inherits(Retake, _Activity);

  function Retake() {
    babelHelpers.classCallCheck(this, Retake);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(Retake).apply(this, arguments));
  }

  babelHelpers.createClass(Retake, [{
    key: "setup",
    value: function setup() {
      var _this = this;

      var finishItNow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      $(document).scroll();
      this.$('.retake-tests-container .activity-link').on('click', this._doRetake);
      this.$('.skip-retake').on('click', function () {
        return _this.startActivity();
      });
      this.addEventListener('startedActivity', function () {
        return _this.endActivity();
      });
      this.addEventListener('endedActivity', function () {
        return _this.activityComplete();
      });
      this.addEventListener('activityComplete', function (event) {
        _this.doNextActivity();

        event.preventDefault();
      });
      if (finishItNow) this.startActivity(); // It's not really complete, but this makes the 'courseComplete' notification work.

      this.activityIsComplete = true;
      ['video', 'document'].forEach(function (type) {
        _Listener.default.addEventListener("".concat(type, "Processed"), _this.handleVideoProcessed);

        _Listener.default.addEventListener("".concat(type, "Error"), _this.handleVideoError);

        _Listener.default.addEventListener("".concat(type, "Accepted"), _this.handleVideoAccepted);

        _Listener.default.addEventListener("".concat(type, "Rejected"), _this.handleVideoRejected);

        _this.addEventListener("unload", function () {
          _Listener.default.removeEventListener("".concat(type, "Processed"), _this.handleVideoProcessed);

          _Listener.default.removeEventListener("".concat(type, "Error"), _this.handleVideoError);

          _Listener.default.removeEventListener("".concat(type, "Accepted"), _this.handleVideoAccepted);

          _Listener.default.removeEventListener("".concat(type, "Rejected"), _this.handleVideoRejected);
        });
      });
    }
  }, {
    key: "handleVideoProcessed",
    value: function handleVideoProcessed(_ref) {
      var data = _ref.data;
      var item = this.$('.activity-link[data-activity-id="' + data.activity.id + '"]');

      if (item.length) {
        item.find('.item-status-text, .item-status-icon').html("\n\t\t\t\t<i>Pending instructor review...</i>\n\t\t\t");
        item.find('.item-status-icon').append("<span class='btn'>View</span>");
      }
    }
  }, {
    key: "handleVideoError",
    value: function handleVideoError(_ref2) {
      var data = _ref2.data;
      var item = this.$('.activity-link[data-activity-id="' + data.activity.id + '"]');

      if (item.length) {
        item.find('.item-status-text, .item-status-icon').html("\n\t\t\t\t<i>Waiting for submission...</i>\n\t\t\t");
        item.find('.item-status-icon').append("<span class='btn'>View</span>");
      }
    }
  }, {
    key: "handleVideoAccepted",
    value: function handleVideoAccepted(_ref3) {
      var data = _ref3.data;
      var item = this.$('.activity-link[data-activity-id="' + data.activity.id + '"]');

      if (item.length) {
        item.parent().remove();
      }
    }
  }, {
    key: "handleVideoRejected",
    value: function handleVideoRejected(_ref4) {
      var data = _ref4.data;
      var item = this.$('.activity-link[data-activity-id="' + data.activity.id + '"]');

      if (item.length) {
        item.find('.item-status-text, .item-status-icon').html("\n\t\t\t\t<b>New submission requested by <span class='person-name'></span></b>\n\t\t\t\t<i>Requested at ".concat(new Date(data.time).format('F j, Y g:i A'), "</i>\n\t\t\t"));
        item.find('.person-name').text(data.submitter.name);
        item.find('.item-status-icon').append("<span class='btn'>View</span>");
      }
    }
  }, {
    key: "_doRetake",
    value: function _doRetake(event) {
      var target = event.currentTarget;
      this.doSpecificActivity(target.dataset.activity);
      event.preventDefault();
      return false;
    }
  }]);
  return Retake;
}(_base.default), (babelHelpers.applyDecoratedDescriptor(_class.prototype, "handleVideoProcessed", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "handleVideoProcessed"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "handleVideoError", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "handleVideoError"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "handleVideoAccepted", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "handleVideoAccepted"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "handleVideoRejected", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "handleVideoRejected"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "_doRetake", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "_doRetake"), _class.prototype)), _class);
exports.default = Retake;